/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';

import axios from 'axios';

//import TimeBlock from '../containers/timeline/TimeBlock';
//import dateFormat from "dateformat";
//import PerfectScrollbar from "react-perfect-scrollbar";
//import WeekBlock from "../containers/timeline/WeekBlock";
//import ScrollMenu from "react-horizontal-scrolling-menu";
//import { StickyContainer, Sticky } from 'react-sticky';
//import ScrollArea from "react-scrollbar";
//import { StickyContainer, Sticky } from "react-sticky";
//import $ from "jquery";
//import moment, { weekdays } from "moment";

import TimelineWeekItem from '../components/timeline/TimelineWeekItem';

import Tooltip from '@material-ui/core/Tooltip';
import fileDownload from 'js-file-download';

class TimeLineWeek extends Component {
  state = {
    toWeek: new Date().getDay(),
    gubun: 'LIVE',
  };
  _isMounted = false;
  componentDidMount = () => {
    this._isMounted = true;

    //const toWeek = new Date().getDay()
    //console.log(toWeek)
    this._getSameCode();
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };
  _getSameCode = async () => {
    const result = await this._getSameCodeApi();
    const intReturn = result.data[0].intReturn;
    const sameCode = result.data[0].sameCode;

    if (intReturn === 0) {
      if (this._isMounted) {
        this.setState({
          sameCode,
        });
      }

      this._getContent();
    }
  };
  _getSameCodeApi = () => {
    const { apiUrl } = this.props;

    return axios
      .post(apiUrl + '/getSameCode', {
        params: {},
      })
      .then((response) => response)
      .catch((error) => {
        // alert('오류가 발생했습니다.');
      });
  };

  _getContent = async () => {
    //const { loginId } = this.props;

    const result = await this._getContentApi();
    const intReturn = result.data[0].intReturn;
    const contentList = result.data[0].listData;

    //console.log(contentList)
    if (intReturn === 0) {
      if (this._isMounted) {
        this.setState({
          contentList,
        });
      }
    }
  };
  _getContentApi = () => {
    const { apiUrl, loginId } = this.props;
    const { sameCode } = this.state;
    //const sameCode = 202010;
    //const { sameCode } = this.props.childProps;

    return axios
      .post(apiUrl + '/eventContent', {
        params: {
          loginId: loginId,
          sameCode: sameCode,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert('오류가 발생했습니다.');
      });
  };

  _renderWeek = (week) => {
    const { contentList, gubun } = this.state;

    const weekContent = contentList.filter((item, index) => {
      return gubun === 'LIVE'
        ? parseInt(item.weekNo) === parseInt(week)
        : parseInt(item.weekNoTv) === parseInt(week);
    });
    //console.log(weekContent)
    //return weekContent

    const list = weekContent.map((item, index) => {
      return (
        <TimelineWeekItem
          key={index}
          contentSerial={item.contentSerial}
          title={item.title}
          img={item.img}
          restrictionCode={item.restrictionCode}
          weekNo={item.weekNo}
          weekTime={item.weekTime}
          weekNoTv={item.weekNoTv}
          weekTimeTv={item.weekTimeTv}
          comment={item.comment}
          comment1={item.comment1}
          comment2={item.comment2}
          gubun={gubun}
          dd
        />
      );
    });

    return list;
  };
  _onClose = () => {
    const { setTimelineWeek } = this.props;
    setTimelineWeek(false);
  };
  _onChange = (gubun) => {
    const { contentList } = this.state;
    //console.log(contentList)

    if (gubun === 'LIVE') {
      contentList.sort(function (a, b) {
        return a.weekTime > b.weekTime ? 1 : a.weekTime < b.weekTime ? -1 : 0;
      });
    } else {
      contentList.sort(function (a, b) {
        return a.weekTimeTv > b.weekTimeTv
          ? 1
          : a.weekTimeTv < b.weekTimeTv
          ? -1
          : 0;
      });
    }

    this.setState({
      gubun,
    });
  };
  _goTimeline = () => {
    const { gubun } = this.state;
    const { setTimeline, setTvline } = this.props;
    //setTimelineWeek(false)
    if (gubun === 'LIVE') {
      setTimeline(true);
    } else {
      setTvline(true);
    }
  };
  _download = () => {
    const { gubun } = this.state;
    let url;
    let filename;

    if (gubun === 'LIVE') {
      url = 'https://www.aniplustv.com/download/weektimeline2024_4.xlsx';
      filename = '2024년_4분기_요일별_시간표.xlsx';
    } else {
      url = 'https://www.aniplustv.com/download/weektimeline2024_4.xlsx';
      filename = '2024년_4분기_요일별_시간표.xlsx';
    }

    axios
      .get(url, {
        responseType: 'blob',
      })
      .then((res) => {
        fileDownload(res.data, filename);
      });
  };
  render() {
    const { contentList, toWeek, gubun, sameCode } = this.state;
    const { imgUrl } = this.props;
    let sameTitle;
    let yy;
    let qu;
    if (sameCode === null || sameCode === undefined || sameCode === '') {
      sameTitle = '';
    } else {
      yy = sameCode.toString().substring(0, 4) + '년 ';
      qu = sameCode.toString().substr(4, 2);
      if (qu === '01') {
        sameTitle = yy + '1분기';
      } else if (qu === '04') {
        sameTitle = yy + '2분기';
      } else if (qu === '07') {
        sameTitle = yy + '3분기';
      } else if (qu === '10') {
        sameTitle = yy + '4분기';
      }
      //console.log(yy, qu)
    }
    return (
      <Fragment>
        <div className="detail_layer_pop">
          <div className="time_tblWrap schWrap">
            <div className="close">
              <a onClick={this._onClose} style={{ cursor: 'pointer' }}>
                닫기
              </a>
            </div>
            <div className="time_tblContent">
              <div className="quick">
                <Tooltip title={gubun + ' 요일별 시간표 다운로드'}>
                  <a onClick={this._download} style={{ cursor: 'pointer' }}>
                    <img src={imgUrl + '/img/etc/download_btn.jpg'} />
                  </a>
                </Tooltip>
                <Tooltip title={gubun + ' 전체 편성표 보기'}>
                  <a onClick={this._goTimeline} style={{ cursor: 'pointer' }}>
                    <img src={imgUrl + '/img/etc/btn_schedule.png'} />
                  </a>
                </Tooltip>
              </div>
              <div className="time_tblHead">
                <h1>
                  <b>{sameTitle}</b>
                </h1>
                <div className="tab_menu">
                  <button
                    type="button"
                    onClick={() => this._onChange('LIVE')}
                    className={gubun === 'LIVE' ? 'active' : null}
                  >
                    <span
                      style={
                        gubun === 'LIVE'
                          ? { fontFamily: 'GmarketSansBold' }
                          : null
                      }
                    >
                      LIVE/TV 시간표
                    </span>
                  </button>
                  {/*<button type="button" onClick={()=>this._onChange('TV')} className={gubun === 'TV' ? "active" : null }><span style={gubun==='TV' ? { fontFamily: 'GmarketSansBold'} : null }>TV 시간표</span></button>*/}
                </div>
              </div>
              <div className="time_tblBody">
                <dl className={toWeek === 1 ? 'active' : null}>
                  <dt>월</dt>
                  <dd>{contentList ? this._renderWeek(1) : null}</dd>
                </dl>
                <dl className={toWeek === 2 ? 'active' : null}>
                  <dt>화</dt>
                  <dd>{contentList ? this._renderWeek(2) : null}</dd>
                </dl>
                <dl className={toWeek === 3 ? 'active' : null}>
                  <dt>수</dt>
                  <dd>{contentList ? this._renderWeek(3) : null}</dd>
                </dl>
                <dl className={toWeek === 4 ? 'active' : null}>
                  <dt>목</dt>
                  <dd>{contentList ? this._renderWeek(4) : null}</dd>
                </dl>
                <dl className={toWeek === 5 ? 'active' : null}>
                  <dt>금</dt>
                  <dd>{contentList ? this._renderWeek(5) : null}</dd>
                </dl>
                <dl className={toWeek === 6 ? 'active' : null}>
                  <dt>토</dt>
                  <dd>{contentList ? this._renderWeek(6) : null}</dd>
                </dl>
                <dl className={toWeek === 7 ? 'active' : null}>
                  <dt>일</dt>
                  <dd>{contentList ? this._renderWeek(7) : null}</dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(TimeLineWeek));
